<template>
  <v-container
    style="position: relative; width: 100%; justify-content: center; height: 100%; background: #FFFFFF 0% 0% no-repeat padding-box; opacity: 1;">

    <div class="text-center">

      <br>

      <div v-if="pagar == false" class="rectangulo">

        <div class="valor">
          <b> Valor total a pagar</b>
        </div>

        <br>

        <div :class="priceBox" class="text-center">
          <b class="precio">{{ formatPrice(servicesData.priceTotal) }}</b>
        </div>

        <br>

      </div>

      <br>
      <br>

      <div v-if="pagar != false" :class="summaryTitle">
        <b>Este es el resumen del SOAP que estás contratando</b>
        <br>
        <br>
        <br>
      </div>

      <template>

        <v-data-table :footer-props="{ 'items-per-page-text': '' }" :headers="headers" :items="arrayShoppingCart"
          :items-per-page="isMobile ? 1 : 5" class="elevation-1 table" no-data-text="CARRITO VACÍO ¡AÑADE TU SOAP!">
          <template v-slot:top>
            <v-dialog v-if="screen > 767" v-model="dialogDelete" max-width="600px">
              <v-card>

                <v-card-title class="text-h5">
                  <div class="titleBox">
                    <b class="title1">¿Estás seguro de </b>
                    <b class="title2">eliminar</b>
                    <b class="title1">este producto?</b>
                  </div>
                  <div :class="dialogCarBox">
                    <b>Vehículo: {{ selectedItem ? selectedItem.carData.patente : '' }}</b><b
                      style="font-weight: normal;">{{ selectedItem ? selectedItem.carData.model : '' }}</b>
                  </div>
                </v-card-title>

                <v-card-actions>

                  <v-spacer></v-spacer>
                  <v-btn class="btnClosePopUp" text @click="closeDelete">Cancelar</v-btn>
                  <v-btn class="btnConfirmPopUp" id="quitarOtro_3" text @click="deleteItemConfirm">Confirmar</v-btn>
                  <div class="space"></div>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-else v-model="dialogDelete" max-width="360px">
              <v-card>

                <v-card-title class="text-h5">
                  <div class="titleBoxMobile">
                    <b class="title1Mobile">¿Estás seguro de<span
                        style="margin-left: 2%; color:rgba(51,51,51, 1)">eliminar</span><br>este
                      producto?</b>
                  </div>
                </v-card-title>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <div class="btnBoxMobile">
                    <v-btn class="btnClosePopUp2" text @click="closeDelete">Cancelar</v-btn>
                    <br><br>
                    <v-btn class="btnConfirmPopUp2" id="quitarOtro_3" text @click="deleteItemConfirm">Confirmar</v-btn>
                    <div class="space"></div>
                  </div>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>

          </template>

          <template v-slot:item.actions="{ item }">
            <div style="cursor: pointer;" @click="deleteItem(item)">
              <v-icon small class="mr-2 trash">
                mdi-delete
              </v-icon>
              <span style="color:#D5362F;">Eliminar</span>
            </div>
          </template>

          <template v-slot:item.carData.price="{ item }">
              <label style="margin:auto">{{ formatPrice(item.carData.price) }}</label>
          </template>

        </v-data-table>

      </template>

      <br>
      <br>

      <div v-if="pagar != true" class="finalBox">

        <b class="question">¿QUIERES AGREGAR OTRO VEHÍCULO?</b>
        <br v-if="screen <= 767">
        <br v-if="screen <= 767">
        <v-btn class="button3" id="agregarOtro_3" @click="NewCarro()">Agregar otro </v-btn>
        <br v-if="screen <= 767">
        <br v-if="screen <= 767">
        <v-btn v-if="screen > 767" class="button2" @click="obtenerToken()" id="confirmar_3">Continuar pago</v-btn>

        <v-btn v-if="screen <= 767" class="button2" style="margin-top: 5%" @click="obtenerToken()" id="confirmar_3">
          Continuar Pago
        </v-btn>

      </div>

      <v-form ref="form" v-model="valid">

        <v-col v-if="pagar != false" style="margin:auto;">

          <br>

          <div :class="summaryBox">

            <br>

            <b :class="summaryTitle">Resumen de tu contratación</b>

            <div :class="summaryBanner">

              <div v-if="screen > 767">
                <v-img contain :src="SummaryBanner" :class="bannerImage" />

              </div>

              <div v-else>
                <br>
                <v-img contain :src="SummaryBannerMobile" :class="bannerImage" />
              </div>

              <b :class="summaryBannerTitle">Seguro obligatorio de accidentes personales</b>

              <br>
              <br>

            </div>

            <br>

            <div :class="summaryDataBox">

              <br>
              <b :class="summaryDataTitle">Detalles del pago</b>

              <hr style="border:none;height: 2px;background-color: rgba(231, 233, 235, 1);width: 90%; margin: auto;">

              <div v-for="(item, index) in arrayShoppingCart" :key="index" :class="summaryPrices">
                <span>{{ item.carData.model }}</span>
                <span>{{ formatter.format(item.carData.price) }}</span>
              </div>

              <hr style="border:none;height: 2px;background-color: rgba(231, 233, 235, 1);width: 90%; margin: auto;">

              <div :class="summaryPricesTotal">
                <span>Total:</span>
                <span>{{ formatter.format(servicesData.finalPrice) }}</span>
              </div>

              <br>

            </div>

            <br>
            <br>

          </div>

          <br>
          <br>
          <br>

          <b class="title">INGRESE RUT DEL PAGADOR</b>

          <br>
          <br>

          <div>
            <label :class="patentLabelView"><b>Ingrese el RUT</b></label>
            <v-text-field v-model="newRut" :rules="rutRules" required solo :class="patentFieldView" hide-details="auto"
              @change="changeRut">
            </v-text-field>
          </div>

        </v-col>

        <br>

        <v-col v-if="pagar != false">

          <div class="checkbox">

            <v-checkbox style="margin-top:2.5%" v-model="conditions" :rules="conditionsRules" required dense
              @change="sendParams()">
            </v-checkbox>

            <label>
              AUTORIZACIÓN PARA TRATAMIENTO DE DATOS PERSONALES: Autorizo que mi información personal sea recopilada,
              almacenada, tratada y divulgada tanto por Southbridge como por Marsh Corredores de Seguros, según la normativa vigente
              y conforme con el Acuerdo de Privacidad contenido en www.southbridgeseguros.cl y las políticas propias de
              la compañía aseguradora.
            </label>

          </div>

          <br>
          <br>

        </v-col>

      </v-form>

    </div>

  </v-container>
</template>

<script>
import RutUtils from "../utils/rut.utils";
// import ShieldService from "../services/shield.service";

import CryptoJS from 'crypto-js';
import swal from 'sweetalert';
import Vue from "vue";

import FundacionLasRosasLogo from '@/assets/images/FundacionLasRosasLogo.svg';
import BuinZooLogo from '@/assets/images/BuinZooLogo.svg';
import CareLogo from '@/assets/images/CareLogo.svg';
import BomberosLogo from '@/assets/images/BomberosLogo.svg';
import SummaryBanner from '@/assets/images/SummaryBanner.png';
import SummaryBannerMobile from '@/assets/images/SummaryBannerMobile.png';
import WebpayLogo from '@/assets/images/webpayLogo.svg';

import { VueReCaptcha } from 'vue-recaptcha-v3'
const { VUE_APP_RECAPTCHA3_SITE_KEY } = process.env;

Vue.use(VueReCaptcha, { siteKey: VUE_APP_RECAPTCHA3_SITE_KEY })

export default {

  name: "PlanForm",
  props: ["carData", "propietarioData", "planData", "servicesData", "arrayShoppingCart", "donationData"],
  data: () => ({
    secretKey: process.env.VUE_APP_CRYPT,
    pathname: window.location.pathname,
    donateOptions: [
      { value: 'Fundación Las Rosas', label: 'Ayuda a mantener los cuidados de los 2.200 adultos mayores a lo largo del país.', image: FundacionLasRosasLogo, name: 'LasRosas' },
      { value: 'BuinZoo', label: 'Súmate para conservar la naturaleza y entregar los cuidados necesarios de los animales.', image: BuinZooLogo, name: 'BuinZoo' },
      { value: 'Fundación Care', label: 'Colabora para que las personas que estén pasando por el difícil camino del cáncer, obtengan ayuda gratuita.', image: CareLogo, name: 'donationCare' },
      { value: 'Bomberos', label: 'Aporta a nuestros Bomberos de Chile y ¡haz la diferencia!', image: BomberosLogo, name: 'Bomberos' },
    ],
    WebpayLogo,
    typePlan: null,
    SummaryBanner,
    SummaryBannerMobile,
    isMobile: window.innerWidth <= 767,
    status: false,
    donate: false,
    screen: window.screen.width,
    typeCliente: null,
    keygen: null,
    priceTotal: 0,
    priceBox: null,
    selectedItem: null,
    dialogCarBox: null,
    donateTitle: null,
    btnBackView: null,
    btnPayView: null,
    buttonOptionsBox: null,
    summaryBannerTitle: null,
    bannerImage: null,
    buttonGroup: null,
    summaryTitle: null,
    summaryBox: null,
    summaryDataBox: null,
    summaryDataTitle: null,
    summaryPrices: null,
    summaryBanner: null,
    summaryPricesTotal: null,
    donateButton: null,
    donateBox: null,
    donateDescription: null,
    donateMessageBox: null,
    donateMessageFirst: null,
    donateMessageSecond: null,
    radioOption: null,
    donateOptionsBox: null,
    noDonarOption: null,
    webpayBox: null,
    webpayTitle: null,
    btnPayBox: null,

    patentFieldView: null,
    patentLabelView: null,
    planId: null,
    type: null,
    token: null,
    pagar: false,
    conditions: null,
    dialog: false,
    valid: false,
    switchFormaPago: null,
    formatter: new Intl.NumberFormat("es-CL", {
      style: "currency",
      currency: "CLP",
    }),
    webPayUrl: process.env.VUE_APP_WEBPAY_URL,
    newRut: "",
    dialogDelete: false,
    dialog: false,
    editedIndex: -1,
    currentPage: 1,
    itemsPerPage: 5,
    editedItem: {
      patenteNumber: '',
      typeVehicle: '',
      modelVehicle: '',
      personEmail: '',
      price: 0,
    },
    defaultItem: {
      patenteNumber: '',
      typeVehicle: '',
      modelVehicle: '',
      personEmail: '',
      price: 0,
    },
    headers: [
      { text: 'Patente', align: 'start', sortable: false, value: 'carData.patente', align: 'center' },
      { text: 'Tipo de Vehículo', value: 'carData.type', align: 'center', sortable: false },
      { text: 'Modelo', value: 'carData.model', align: 'center', sortable: false },
      { text: 'Correo', value: 'propietarioData.email', align: 'center', sortable: false },
      { text: 'Valor SOAP', value: 'carData.price', align: 'center', sortable: false },
      { text: 'Eliminar', value: 'actions', sortable: false, align: 'center' },
    ],
    confirmRules: [(v) => !!v || "Selecciona una opción"],
    rutRules: [
      (v) => !!v || "Rut es requerido",
      (v) => RutUtils.validateRut(v) || "Rut no válido",
    ],
    rutRules2: [
      (v) => !!v || "Rut del cliente es requerido",
      (v) => RutUtils.validateRut(v) || "Rut no válido",
    ],
    contrasenaRules: [
      (v) => !!v || "La contraseña es requerida",
    ],
    conditionsRules: [
      (v) => !!v || "",
    ]
  }),
  watch: {
    'servicesData.entityDonation'(newValue) {
      if (newValue) {
        this.donate = null;
      }
    },
    donate(newValue) {
      if (newValue === false) {
        this.servicesData.entityDonation = null;
        this.servicesData.finalPrice = this.servicesData.finalPrice - this.servicesData.priceDonation
        this.servicesData.priceDonation = null;
      }
    },
    'servicesData.priceDonation'(newValue, oldValue) {
      if (newValue === null) {
        return;
      }
      if (oldValue != null) {
        this.servicesData.finalPrice -= oldValue;
      }
      this.servicesData.finalPrice += newValue;
    }
  },
  async mounted() {
    this.servicesData.propietario = 'true';
    this.pagar = false;

    // const query = this.$route.query;

    if (this.screen > 767) {
      this.patentFieldView = 'patentFieldView';
      this.priceBox = 'priceBox';
      this.dialogCarBox = 'dialogCarBox';
      this.donateBox = 'donateBox';
      this.donateMessageBox = 'donateMessageBox';
      this.donateMessageFirst = 'donateMessageFirst';
      this.donateMessageSecond = 'donateMessageSecond';
      this.radioOption = 'radioOption';
      this.donateOptionsBox = 'donateOptionsBox';
      this.noDonarOption = 'noDonarOption';
      this.buttonOptionsBox = 'buttonOptionsBox';
      this.donateButton = 'donateButton';
      this.donateTitle = 'donateTitle';
      this.buttonGroup = 'buttonGroup';
      this.summaryBox = 'summaryBox';
      this.summaryTitle = 'summaryTitle';
      this.summaryBanner = 'summaryBanner';
      this.bannerImage = 'bannerImage';
      this.summaryBannerTitle = 'summaryBannerTitle';
      this.summaryDataBox = 'summaryDataBox';
      this.summaryPrices = 'summaryPrices';
      this.summaryPricesTotal = 'summaryPricesTotal';
      this.patentLabelView = 'patentLabelView';
      this.btnBackView = 'btnBackView';
      this.btnPayView = 'btnPayView';
      this.summaryDataTitle = 'summaryDataTitle';
      this.donateDescription = 'donateDescription';
      this.webpayBox = 'webpayBox';
      this.webpayTitle = 'webpayTitle';
      this.btnPayBox = 'btnPayBox';
    } else if (this.screen <= 767) {
      this.patentFieldView = 'patentFieldView2';
      this.priceBox = 'priceBox2';
      this.dialogCarBox = 'dialogCarBox2';
      this.donateBox = 'donateBox2';
      this.donateMessageBox = 'donateMessageBox2';
      this.donateMessageFirst = 'donateMessageFirst2';
      this.donateMessageSecond = 'donateMessageSecond2';
      this.radioOption = 'radioOption2';
      this.donateOptionsBox = 'donateOptionsBox2';
      this.noDonarOption = 'noDonarOption2';
      this.buttonOptionsBox = 'buttonOptionsBox2';
      this.donateButton = 'donateButton2';
      this.donateTitle = 'donateTitle2';
      this.buttonGroup = 'buttonGroup2';
      this.summaryBox = 'summaryBox2';
      this.summaryTitle = 'summaryTitle2';
      this.summaryBanner = 'summaryBanner2';
      this.bannerImage = 'bannerImage2';
      this.summaryBannerTitle = 'summaryBannerTitle2';
      this.summaryDataBox = 'summaryDataBox2';
      this.summaryPrices = 'summaryPrices2';
      this.summaryPricesTotal = 'summaryPricesTotal2';
      this.patentLabelView = 'patentLabelView2';
      this.btnBackView = 'btnBackView2';
      this.btnPayView = 'btnPayView2';
      this.donateDescription = 'donateDescription2';
      this.summaryDataTitle = 'summaryDataTitle2';
      this.webpayBox = 'webpayBox2';
      this.webpayTitle = 'webpayTitle2';
      this.btnPayBox = 'btnPayBox2';
    }

  },
  methods: {
    async setAmount(donation) {
      this.servicesData.priceDonation = donation.amount;
      this.servicesData.secretDonation = donation.secret;
    },
    async obtenerToken() {
      this.pagar = true;
    },
    deleteItem(item) {
      this.selectedItem = item;
      this.editedIndex = this.arrayShoppingCart.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    async deleteItemConfirm() {

      this.arrayShoppingCart.splice(this.editedIndex, 1);

      this.servicesData.priceTotal = this.arrayShoppingCart.reduce((accumulator, item) => accumulator + (item.carData.price || 0), 0);

      const arrayShoppingCartLocal = JSON.stringify(this.arrayShoppingCart);
      const encryptedArrayShoppingCartLocal = CryptoJS.AES.encrypt(arrayShoppingCartLocal, this.secretKey).toString();
      localStorage.setItem('arrayShoppingCart', encryptedArrayShoppingCartLocal);

      const servicesDataLocal = JSON.stringify(this.servicesData);
      const encryptedServicesDataLocal = CryptoJS.AES.encrypt(servicesDataLocal, this.secretKey).toString();
      localStorage.setItem('servicesData', encryptedServicesDataLocal);

      if (this.arrayShoppingCart.length == 0) {
        swal({
          title: "¡No posee SOAP's en su carrito!",
          text: "Será redirigido al inicio de la plataforma",
          icon: "info",
          button: "Ok",
        }).then(() => {
          this.selectedItem = null;
          window.location.href = `/${this.servicesData.typeCliente}/inicio`
          // this.$router.push({ path: `/${this.servicesData.typeCliente}/inicio` });
        });
      } else {
        this.closeDelete();
      }

    },
    closeDelete() {
      this.dialogDelete = false;
      this.selectedItem = null;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      })
    },
    back() {
      this.$emit("back");
    },
    btnBackToPay() {
      window.location.href = `/${this.servicesData.typeCliente}/inicio`
      // this.$router.push({ path: `/${this.servicesData.typeCliente}/inicio` });
    },
    NewCarro() {
      if (this.arrayShoppingCart.length >= 20) {
        swal({
          title: "¡Límite alcanzado!",
          text: "No puedes agregar más elementos al carrito.",
          icon: "info",
          button: "Ok",
        });
        return; // Salir de la función si se alcanza el límite
      } else {
        const agregarOtro_3 = document.getElementById('agregarOtro_3');
        // this.token = null;

        localStorage.removeItem('propietarioData');
        localStorage.removeItem('carData');
        this.servicesData.newCar = true;

        const servicesDataLocal = JSON.stringify(this.servicesData);
        const encryptedServicesDataLocal = CryptoJS.AES.encrypt(servicesDataLocal, this.secretKey).toString();
        localStorage.setItem('servicesData', encryptedServicesDataLocal);

        window.location.href = `/${this.servicesData.typeCliente}/inicio`
        // this.$router.push({ path: `/${this.servicesData.typeCliente}/inicio` });
      }
    },
    sendParams() {
      var params = {
        // token: this.token,
        conditions: this.conditions,
      };
      this.$emit("getToken", params);
    },
    formatPrice(number) {
      // console.log('number:', number);
      return this.formatter.format(number);
    },
    async changeRut(rut) {
      this.servicesData.rutPropietario = RutUtils.formatRut(rut);
      this.newRut = RutUtils.formatRut(rut);
    },
  },
};
</script>

<style lang="css" scoped>
@media (max-width: 767px) {

  /* Color de fondo para el header de la columna Patente */
  .v-data-table thead th:nth-child(1) {
    background-color: rgba(227, 233, 253, 1);
    /* Color E3E9FD */
    color: rgba(51, 51, 51, 1);
    font-weight: bold;
  }

  /* Color de fondo para las celdas de la columna Patente */
  .v-data-table tbody td:nth-child(1) {
    background-color: rgba(227, 233, 253, 1);
    /* Color E3E9FD */
    color: rgba(51, 51, 51, 1);
    font-weight: bold;
  }
}

.btnPayBox {
  display: flex;
  align-items: center;
  gap: 4%;
  justify-content: center;
}

.btnPayBox2 {
  display: block;
  align-items: center;
  justify-content: center;
  /* background-color: yellowgreen; */
}

.webpayTitle {
  color: rgba(45, 56, 124, 1);
  font-weight: bold;
  font-size: 24px;
}

.webpayTitle2 {
  color: rgba(45, 56, 124, 1);
  font-weight: bold;
  font-size: 20px;
}

.webpayBox {
  display: flex;
  align-items: center;
  gap: 4%;
  justify-content: center;
}

.webpayBox2 {
  display: block;
  align-items: center;
  justify-content: center;
}

.summaryDataTitle {
  font-size: 20px;
  text-align: left;
  display: block;
  margin-left: 5.2%;
}

.summaryDataTitle2 {
  font-size: 16px;
  text-align: left;
  display: block;
  margin-left: 5.2%;
}

.donateDescription2 {
  text-align: left;
  /* background-color: yellowgreen; */
  font-size: 12px;
  margin-top: -2%;
  margin-left: 1%;
}

.btnBackView {
  width: 100%;
  max-width: 200px;
  height: 40px !important;
  background: #2D387C 0% 0% no-repeat padding-box !important;
  /* background: #4F74E3 0% 0% no-repeat padding-box !important; */
  border-radius: 8px;
  text-align: center;
  letter-spacing: 0.66px;
  color: white !important;
  opacity: 1;
  font-weight: bold;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
}

.btnBackView2 {
  width: 90%;
  /* max-width: 200px; */
  height: 40px !important;
  background: #2D387C 0% 0% no-repeat padding-box !important;
  /* background: #4F74E3 0% 0% no-repeat padding-box !important; */
  border-radius: 8px;
  text-align: center;
  letter-spacing: 0.66px;
  color: white !important;
  opacity: 1;
  font-weight: bold;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  margin-bottom: 10%;
}

.btnPayView {
  width: 100%;
  max-width: 200px;
  height: 40px !important;
  /* background: #2D387C 0% 0% no-repeat padding-box !important; */
  background: #4F74E3 0% 0% no-repeat padding-box !important;
  border-radius: 8px;
  text-align: center;
  letter-spacing: 0.66px;
  color: white !important;
  opacity: 1;
  font-weight: bold;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
}

.btnPayView2 {
  width: 90%;
  height: 40px !important;
  /* background: #2D387C 0% 0% no-repeat padding-box !important; */
  background: #4F74E3 0% 0% no-repeat padding-box !important;
  border-radius: 8px;
  text-align: center;
  letter-spacing: 0.66px;
  color: white !important;
  opacity: 1;
  font-weight: bold;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
}

.patentLabelView {
  font-family: 'Inter', sans-serif;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  margin-left: -18%;
}

.patentLabelView2 {
  font-family: 'Inter', sans-serif;
  color: rgba(51, 51, 51, 1);
  margin-right: 50%;
  font-size: 80%;
}

.summaryPrices {
  display: grid;
  grid-template-columns: 2fr 1fr;
  align-items: center;
  gap: 20%;
  margin: auto;
  margin-top: 2%;
  margin-bottom: 2%;
}

.summaryPrices span:first-child {
  flex: 2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 10%;
  text-align: left;
  /* Alinea el precio a la derecha */
}

.summaryPrices span:last-child {
  flex: 1;
  /* Precio ocupa menos espacio */
  text-align: left;
  /* Alinea el precio a la derecha */
  margin-left: 32%;
}

.summaryPrices2 {
  display: grid;
  grid-template-columns: 2fr 1fr;
  align-items: center;
  gap: 20%;
  margin: auto;
  margin-top: 2%;
  margin-bottom: 2%;
}

.summaryPrices2 span:first-child {
  flex: 2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 10%;
  text-align: left;
  /* Alinea el precio a la derecha */
}

.summaryPrices2 span:last-child {
  flex: 1;
  /* Precio ocupa menos espacio */
  text-align: left;
  /* Alinea el precio a la derecha */
  margin-left: -10%;
}

.summaryPricesTotal {
  display: grid;
  grid-template-columns: 2fr 1fr;
  align-items: center;
  gap: 20%;
  margin: auto;
  margin-top: 2%;
  margin-bottom: 2%;
}

.summaryPricesTotal span:first-child {
  flex: 2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 10%;
  text-align: left;
  /* Alinea el precio a la derecha */
  font-weight: bold;
}

.summaryPricesTotal span:last-child {
  flex: 1;
  /* Precio ocupa menos espacio */
  text-align: right;
  /* Alinea el precio a la derecha */
  margin-right: 42%;
  font-weight: bold;
}

.summaryPricesTotal2 {
  display: grid;
  grid-template-columns: 2fr 1fr;
  align-items: center;
  /* gap: 15%;  */
  margin: auto;
  margin-top: 2%;
  margin-bottom: 2%;
  position: relative;
}

.summaryPricesTotal2 span:first-child {
  flex: 2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 10%;
  text-align: left;
  font-weight: bold;
}

.summaryPricesTotal2 span:last-child {
  position: absolute;
  right: 7.2%;
  font-weight: bold;
}

.summaryDataBox {
  background-color: white;
  width: 85%;
  margin: auto;
  border-radius: 6px;
  margin-top: 2%;
}

.summaryDataBox2 {
  background-color: white;
  width: 85%;
  margin: auto;
  border-radius: 6px;
  margin-top: 2%;
}

.bannerImage {
  padding: 2%;
  max-width: 95%;
  margin: auto;
}

.bannerImage2 {
  padding: 4%;
  max-width: 90%;
  margin: auto;
  margin-top: -5%;
  margin-bottom: 5%;
}

.summaryBanner {
  background-color: white;
  width: 85%;
  margin: auto;
  border-radius: 6px;
  margin-top: 2%;
}

.summaryBanner2 {
  background-color: white;
  width: 85%;
  margin: auto;
  border-radius: 6px;
}

.summaryBox {
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  width: 75%;
  margin: auto;
}

.summaryBox2 {
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  width: 100%;
  margin: auto;
}

.summaryBannerTitle {
  font-family: 'Inter', sans-serif;
  color: rgba(0, 0, 0, 1);
  font-weight: bold;
  font-size: 22px;
}

.summaryTitle {
  font-family: 'Inter', sans-serif;
  color: rgba(51, 51, 51, 1);
  font-weight: bold;
  font-size: 20px;
}

.summaryTitle2 {
  font-family: 'Inter', sans-serif;
  color: rgba(51, 51, 51, 1);
  font-weight: bold;
  font-size: 16px;
}

.buttonOptionsBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  margin-top: 15px;
}

.donateTitle {
  font-size: 18px;
  margin-bottom: 10px;
  text-align: center;
}

.donateTitle2 {
  font-size: 14px;
  color: rgba(42, 56, 129, 1);
  /* margin-bottom: 10px;  */
  font-weight: 600;
  text-align: center;
}

.buttonGroup {
  display: flex;
  gap: 15px;
  margin-bottom: 3%;
}

.donateButton {
  background-color: white;
  color: rgba(42, 56, 129, 1);
  border: solid 1px rgba(42, 56, 129, 1);
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  width: 200px;
  border-radius: 8px;
  transition: background-color 0.3s ease;
}

.donateButton2 {
  background-color: white;
  color: rgba(42, 56, 129, 1);
  border: solid 1px rgba(42, 56, 129, 1);
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  width: 40%;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  border-radius: 8px;
  transition: background-color 0.3s ease;
  margin: 2%;
}

.donateButton.selected {
  background-color: rgba(42, 56, 129, 1);
  font-weight: bold;
  color: white;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
}

.donateButton2.selected {
  background-color: rgba(42, 56, 129, 1);
  font-weight: bold;
  color: white;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
}

.donateOptionsBox {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-top: 10px;
}

.noDonarOption {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  text-align: left;
}

.noDonarOption2 {
  display: flex;
  padding-top: 4%;
  padding-bottom: 4%;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  text-align: left;
  background-color: #F1F1F1;
  flex-direction: row-reverse;
  border-bottom: 1px solid #D5D5D5;
}

.noDonarOption2 span {
  color: #2D387C;
  font-size: 14px !important;
  margin-right: 5%;
  font-weight: 600 !important;
}

.noDonarOption2 input[type="radio"] {
  margin-right: 2.5%;
}

.radioOption {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
}

.radioOption2:nth-child(2n-1) {
  background-color: #F1F1F1;
}

.radioOption2 {
  display: flex;
  align-items: center;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
  gap: 2%;
  padding: 2%;
}

.donateBox {
  width: 100%;
  border: 1px solid grey;
  text-align: center;
  justify-content: center;
  padding: 2%;
  border-radius: 6px;
}

.donateBox2 {
  width: 100%;
  border: 1px solid grey;
  text-align: center;
  justify-content: center;
  border-radius: 6px;
}

.donateMessageBox {
  display: flex;
  width: 100%;
  text-align: center;
  justify-content: center;
}

.donateMessageBox2 {
  width: 100%;
}

.donateMessageFirst {
  font-family: 'Inter', sans-serif;
  color: #4F74E3;
  font-weight: bold;
  font-size: 20px;
}

.donateMessageFirst2 {
  font-family: 'Inter', sans-serif;
  color: #2D387C;
  font-weight: bold;
  font-size: 14px;
}

.donateMessageSecond {
  margin-left: 0.6%;
  font-family: 'Inter', sans-serif;
  color: #2D387C;
  font-weight: bold;
  font-size: 20px;
}

.donateMessageSecond2 {
  margin-left: 0.6%;
  font-family: 'Inter', sans-serif;
  color: #2D387C;
  font-weight: bold;
  font-size: 14px;
}

.dialogCarBox {
  font-size: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: 100%;
  margin-top: 2%;
}

.titulo {
  color: rgb(126, 43, 137);
  font-size: 1.5rem;
  font-weight: bold;
  margin: 0px;
  font-family: Nunito;
  text-align: center;
  line-height: 1.2;
}

.subtitulo {
  font-family: Nunito;
  width: 280px;
  text-align: center;
  margin: 15px auto auto;
  line-height: 1.2;
}

.form-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
}


.login {
  display: inline-block;
  box-sizing: border-box;
  border-radius: 0.3rem;
  background-color: rgb(19, 65, 105);
  height: 40px;
  line-height: 40px;
  width: 100%;
  padding: 0px 1.5rem;
  cursor: pointer;
  color: white;
  font-weight: 600;
  margin: auto;
}

#app>div.v-dialog__content.v-dialog__content--active>div>div>div>div>div:nth-child(1)>button {
  height: 36px;
  min-width: 64px;
  padding: 0 16px;
  background-color: rgb(19, 65, 105);
}

.precio {
  height: 40px;
  text-align: center;
  font: Arial;
  font-size: 30px;
  letter-spacing: 0.53px;
  color: rgba(51, 51, 51, 1);
  opacity: 1;
  margin: auto;
}

.patenteNumber {
  width: 138px;
  height: 40px;
  text-align: center;
  font: Arial;
  font-size: 35px;
  letter-spacing: 0.53px;
  color: #4E4E4E;
  text-transform: uppercase;
  opacity: 1;
}

.valor {
  background-color: rgba(51, 51, 51, 1);
  color: #FFF;
  font-family: 'Helvetica';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: -0.24px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding-top: 2%;
  padding-bottom: 2%;
}

.condicion {
  width: 56px;
  height: 21px;
  text-align: center;
  font: Arial;
  font-size: 14px;
  letter-spacing: 0.26px;
  color: #0069B6;
  text-transform: uppercase;
  opacity: 1;
}

.patente {
  width: 76px;
  height: 21px;
  font: Arial;
  font-size: 17px;
  letter-spacing: 0.26px;
  color: #4E4E4E;
  text-transform: uppercase;
  opacity: 1;
}

.webpay {
  width: 80%;
  height: 206px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 6px #00000029;
  border: 1px solid #D5D5D5;
  border-radius: 10px;
  opacity: 1;
  margin: auto;
}

.cenco {
  width: 80%;
  height: 206px;
  background: #753783 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 6px #00000029;
  border: 1px solid #D5D5D5;
  border-radius: 10px;
  opacity: 1;
  margin: auto;
}

.rectangulo {
  box-shadow: 0px 0px 6px #00000029;
  max-width: 420px;
  opacity: 1;
  margin: auto;
  border-radius: 10px;

}

.hrStyle {
  width: 147px;
  height: 0px;
  border: 1px solid #D0D0D0;
  opacity: 1;
  margin: auto;
}

.question {
  color: rgba(51, 51, 51, 1);
  font-family: 'Inter', sans-serif;
  margin-right: 1%;
  font-size: 20px;
}

@media (min-width: 767px) and (max-width: 1000px) {
  .question {
    display: block;
  }
}


.button3 {
  width: 270px;
  height: 50px !important;
  background-color: none !important;
  border-radius: 10px !important;
  opacity: 1;
  border: 2px solid #000000;
  text-align: center;
  font: normal normal normal 20px Arial;
  letter-spacing: 0.66px;
  color: #000000 !important;
  opacity: 1;
  margin-left: 1%;
  font-weight: bold;
}

.button2 {
  width: 270px;
  height: 50px !important;
  background-color: #D5362F !important;
  border-radius: 10px !important;
  opacity: 1;
  text-align: center;
  font: normal normal normal 20px Arial;
  letter-spacing: 0.66px;
  color: white;
  opacity: 1;
  margin-left: 1%;
  font-weight: bold;

}

.finalBox {
  margin-left: -4%;
}

.title {
  color: rgba(51, 51, 51, 1);
  font-weight: bold;
  font-family: 'Inter', sans-serif;
  letter-spacing: -0.36px !important;
}

.labelName {
  text-align: left;
  font: Arial;
  font-size: 12px;
  letter-spacing: 0px;
  color: #333;
  opacity: 1;
  font-weight: bold;
  margin-left: -72%;
  font-family: 'Inter', sans-serif;
  letter-spacing: -0.2px;
  line-height: 38.5px;
}

.checkbox {
  max-width: 540px;
  margin: auto;
  color: #333;
  font-family: 'Inter', sans-serif;
  letter-spacing: -0.2px;
  display: flex;
  text-align: left;
  font-size: 13px;
  margin-bottom: -3%;
}

.payTitleImage {
  color: #2D387C;
  display: flex;
  justify-content: center;
}

.payButtons {
  display: flex;
  justify-content: center;
}

.pay {
  background-color: #EFEFEF;
  /* margin-left: -20%; */
  /* max-width: x100%; */
  width: 100vw;
  position: absolute;
  left: 50%;
  margin-left: -200px;
}

.payTitle {
  font-size: 24px;
  margin-top: 0.5%;
}

.payImage {
  margin-left: 2%;
}

.btnBack {
  width: 270px;
  height: 50px !important;
  background-color: #2D387C !important;
  border-radius: 8px !important;
  opacity: 1;
  text-align: center;
  font: normal normal normal 20px Arial;
  letter-spacing: 0.66px;
  color: white !important;
  opacity: 1;

  font-weight: bold;
}

.btnPay {
  width: 260px;
  height: 50px !important;
  background-color: #4F74E3 !important;
  border-radius: 8px !important;
  opacity: 1;
  text-align: center;
  font: normal normal normal 20px Arial;
  letter-spacing: 0.66px;
  color: white !important;
  opacity: 1;
  margin-left: 6%;
  font-weight: bold;
}

.tableHeaders {
  background-color: #2D387C;
  color: white !important;
  border: 2px solid #2D387C;
}

.text-center {
  text-align: center;
}

.table {
  border: 1px solid #D5D5D5;
  margin-top: -2%;
  margin-bottom: -1%;
}

.btnClosePopUp {
  background-color: none;
  color: #000000;
  border: 2px solid #000000;
  border-radius: 8px;
  font-weight: bold;
  letter-spacing: 0.8px;
  width: 30%;
  margin-top: -2%;
}

.btnClosePopUp2 {
  height: 40px !important;
  background-color: none;
  color: rgba(237, 7, 34, 1);
  border: 1px solid rgba(237, 7, 34, 1);
  border-radius: 8px;
  font-weight: bold;
  letter-spacing: 0.8px;
  width: 100%;
  margin-top: -2%;
}

.btnConfirmPopUp {
  background-color: #D5362F;
  color: #FFF;
  border-radius: 8px;
  font-weight: bold;
  letter-spacing: 0.8px;
  width: 30%;
  margin-top: -2%;
}

.btnConfirmPopUp2 {
  height: 40px !important;
  background-color: #D5362F;
  color: #FFF;
  border-radius: 8px;
  font-weight: bold;
  letter-spacing: 0.8px;
  width: 100%;
  margin-top: -2%;
}

.title1 {
  color: rgba(51, 51, 51, 1);
  font-size: 22px;
}

.title1Mobile {
  color: rgba(51, 51, 51, 1);
  font-size: 20px;
}

.title2 {
  color: rgba(51, 51, 51, 1);
  margin-right: 1%;
  font-size: 22px;

}

.titleBox {
  width: 100%;
  text-align: center;
}

.titleBoxMobile {
  width: 100%;
  margin: auto;
  text-align: center;
  margin-top: 1%;
  margin-bottom: 3%;
}

.btnBoxMobile {
  display: block;
  width: 70%;
}

.patentFieldView {
  width: 300px;
  height: 50px !important;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 1px solid #B2B2B2;
  border-radius: 10px;
  opacity: 1;
  text-transform: uppercase;
  margin: auto;
}

.patentFieldView2 {
  width: 82%;
  height: 50px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 1px solid #B2B2B2;
  border-radius: 10px;
  opacity: 1;
  text-transform: uppercase;
  margin: auto;
}

.priceBox {
  display: flex;
  margin-top: -2%;
}

.priceBox2 {
  display: flex;
  width: 100%;
  text-align: center;
  margin: auto;
}
</style>

<style lang="css">
.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
  background-color: #2D387C;
  color: white !important;
}

.space {
  margin-bottom: 10% !important;
}

.spaceMobile {
  margin-bottom: 4% !important;
}

.trash {
  color: #D5362F !important;

}

.radioOption input[type="radio"] {
  transform: scale(1.5);
  margin: 5px;
}

@media (min-width: 1919px) {
  .patentLabelView {
    font-family: 'Arial', sans-serif;
    color: #333333;
    font-size: 14px;
    margin-left: -14% !important;
  }
}

.v-btn:before {
    background-color: transparent !important;
}
</style>